import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../../../lesson/course-04/lesson-02/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "1f64fa13-7b75-489d-908d-83b0b5248e82",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
];

export default lessonLinks;
